import SearchFlights from "../features/searchFlights/SearchFlights";
import React from "react";
import HeaderLogo from "./HeaderLogo";
import OAGPromoLogo from "./OAGPromoLogo";
import OAGCopyright from "./OAGCopyright";

function ITT() {
  return (
    <div className="container" id="search-results-column">
      <div className="is-flex is-flex-direction-column">
        <HeaderLogo />
        <SearchFlights layout="vertical" />
        <OAGCopyright />
        <OAGPromoLogo />
      </div>
    </div>
  );
}

export default ITT;
